export default __webpack_public_path__ + "static/media/backgroundi.b87b8909.png";